// Retro sound effects using Web Audio API
// No external files needed!

let audioContext = null;

function getAudioContext() {
  if (!audioContext) {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  }
  // Resume if suspended (required after user interaction)
  if (audioContext.state === 'suspended') {
    audioContext.resume();
  }
  return audioContext;
}

// Call this on first user interaction to enable audio
export function initAudio() {
  getAudioContext();
}

// Simple beep sound
export function playBeep(frequency = 440, duration = 0.1, volume = 0.3) {
  try {
    const ctx = getAudioContext();
    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);

    oscillator.frequency.value = frequency;
    oscillator.type = 'square';

    gainNode.gain.setValueAtTime(volume, ctx.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + duration);

    oscillator.start(ctx.currentTime);
    oscillator.stop(ctx.currentTime + duration);
  } catch (e) {
    // Audio not supported, fail silently
  }
}

// Command submit sound - retro "blip"
export function playCommandSound() {
  playBeep(880, 0.05, 0.2);
  setTimeout(() => playBeep(1100, 0.05, 0.15), 50);
}

// New scene/loading complete - triumphant arpeggio
export function playSuccessSound() {
  playBeep(523, 0.1, 0.2);  // C
  setTimeout(() => playBeep(659, 0.1, 0.2), 100);  // E
  setTimeout(() => playBeep(784, 0.15, 0.2), 200); // G
}

// Game over fanfare
export function playGameOverSound() {
  playBeep(784, 0.15, 0.25);  // G
  setTimeout(() => playBeep(659, 0.15, 0.25), 150);  // E
  setTimeout(() => playBeep(523, 0.15, 0.25), 300);  // C
  setTimeout(() => playBeep(392, 0.3, 0.25), 450);   // G low
}

// Error/warning sound
export function playErrorSound() {
  playBeep(200, 0.15, 0.3);
  setTimeout(() => playBeep(150, 0.2, 0.25), 150);
}

// Typing sound - subtle click
export function playTypeSound() {
  playBeep(1200 + Math.random() * 400, 0.02, 0.08);
}

// NPC attitude change - ascending or descending based on direction
export function playAttitudeSound(improved = true) {
  if (improved) {
    playBeep(400, 0.08, 0.15);
    setTimeout(() => playBeep(500, 0.08, 0.15), 80);
    setTimeout(() => playBeep(600, 0.1, 0.15), 160);
  } else {
    playBeep(600, 0.08, 0.15);
    setTimeout(() => playBeep(500, 0.08, 0.15), 80);
    setTimeout(() => playBeep(400, 0.1, 0.15), 160);
  }
}

// Important choice sound - attention-grabbing
export function playChoiceSound() {
  playBeep(660, 0.1, 0.2);
  setTimeout(() => playBeep(880, 0.1, 0.2), 100);
  setTimeout(() => playBeep(660, 0.1, 0.2), 200);
}

// Item pickup sound
export function playItemSound() {
  playBeep(600, 0.05, 0.2);
  setTimeout(() => playBeep(900, 0.1, 0.2), 50);
}
